// @flow

import * as React from 'react';

import Constants from '../Constants';

export const Cloud = (props: { weather: number }) => {
  const classes = ['background-cloud'];
  if (props.weather === Constants.WEATHER_SUNNY) {
    classes.push('background-cloud-sunny');
  } else if (props.weather === Constants.WEATHER_CLOUDY) {
    classes.push('background-cloud-cloudy');
  } else if (props.weather === Constants.WEATHER_RAINY) {
    classes.push('background-cloud-rainy');
  }
  return <div className={classes.join(' ')} />;
};
